import { MessageCircle } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';
import { useLocation } from 'react-router-dom';

/**
 * Sanitiza o número do WhatsApp: remove tudo que não for dígito,
 * garante o código do país 55 (Brasil) e valida tamanho mínimo.
 * Retorna string vazia se inválido (componente não renderiza).
 */
const sanitizeWhatsappNumber = (raw) => {
  if (!raw) return '';
  // Remove tudo que não é dígito (espaços, hífens, parênteses, +, etc)
  let digits = String(raw).replace(/\D/g, '');
  if (!digits) return '';
  // Se começar com 0, remove (DDD discado)
  if (digits.startsWith('0')) digits = digits.replace(/^0+/, '');
  // Se tem 10 ou 11 dígitos (DDD + número), adiciona 55
  if (digits.length === 10 || digits.length === 11) {
    digits = '55' + digits;
  }
  // Se tem 12 ou 13 dígitos (55 + DDD + número), está OK
  // Valida tamanho mínimo (12 = 55 + DDD2 + 8) e máximo (13 = 55 + DDD2 + 9)
  if (digits.length < 12 || digits.length > 13) return '';
  return digits;
};

const WhatsAppFAB = () => {
  const { company } = useSettings();
  const location = useLocation();

  // Oculta em rotas admin (mantém comportamento original em /)
  if (location.pathname.startsWith('/admin')) return null;

  const number = sanitizeWhatsappNumber(company?.whatsapp);
  if (!number) {
    // Sem número válido configurado — não renderiza para evitar 404
    return null;
  }

  const message = encodeURIComponent('Olá! Gostaria de saber mais sobre os kits de alimentos.');
  const href = `https://wa.me/${number}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-fab"
      data-testid="whatsapp-fab"
      aria-label="Contato via WhatsApp"
    >
      <MessageCircle className="w-7 h-7" />
    </a>
  );
};

export default WhatsAppFAB;
